import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Crown, Heart, Flower2, ChevronRight, CreditCard } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

const ICON = { free: Flower2, sorted: Heart, plus: Crown };

export default function PlanCard() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  useEffect(() => { api.get("/billing/me").then((r) => setMe(r.data)).catch(() => {}); }, []);
  if (!me) return null;
  const Icon = ICON[me.plan] || Flower2;
  const renews = me.current_period_end ? new Date(me.current_period_end).toLocaleDateString("en-AU", { day: "numeric", month: "short" }) : null;
  const manage = async () => {
    try { const { data } = await api.post("/billing/portal", { origin_url: window.location.origin }); window.location.href = data.url; }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-3xl border-2 border-[#FDECEF] p-4 shadow-soft" data-testid="plan-card">
      <div className="flex items-center gap-3">
        <span className={`w-11 h-11 rounded-2xl flex items-center justify-center ${me.tier === 2 ? "bg-[#FCEFCF] text-amber-600" : me.tier === 1 ? "bg-[#FCE1E8] text-sorted-rose" : "bg-[#DDEBE1] text-emerald-700"}`}><Icon size={20} strokeWidth={2.5} /></span>
        <div className="flex-1">
          <p className="font-heading font-semibold text-sorted-ink leading-tight" data-testid="plan-card-name">{me.name}</p>
          <p className="text-[11px] text-sorted-slate font-semibold">
            {me.tier === 0 ? "Everything's unlocked during beta" : me.status === "trialing" ? `Free trial · first bill ${renews}` : me.cancel_at_period_end ? `Ends ${renews}` : `Renews ${renews} · ${me.interval}ly`}
          </p>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        <button onClick={() => navigate("/plans")} data-testid="plan-card-plans" className="flex-1 bg-sorted-rose text-white rounded-full py-2.5 text-xs font-bold flex items-center justify-center gap-1">
          {me.tier === 0 ? "Go Sorted" : "Change plan"} <ChevronRight size={14} strokeWidth={3} />
        </button>
        {me.tier > 0 && <button onClick={manage} data-testid="plan-card-manage" className="flex-1 bg-white border-2 border-[#FDECEF] text-sorted-ink rounded-full py-2.5 text-xs font-bold flex items-center justify-center gap-1"><CreditCard size={14} strokeWidth={2.5} /> Manage billing</button>}
      </div>
    </div>
  );
}
